// extracted by mini-css-extract-plugin
export default {"descriptionWrapper":"AvisoRemoverUsuario_descriptionWrapper__M+68G","button":"AvisoRemoverUsuario_button__qIXQs","link":"AvisoRemoverUsuario_link__hhb5t"};